var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPosterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_528_349)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.23356 3.24186C3.07129 4.40414 3.07129 6.27479 3.07129 10.0161V13.9844C3.07129 17.7257 3.07129 19.5963 4.23356 20.7586C5.39584 21.9209 7.26649 21.9209 11.0078 21.9209H12.9919C16.7332 21.9209 18.6039 21.9209 19.7662 20.7586C20.9284 19.5963 20.9284 17.7257 20.9284 13.9844V10.0161C20.9284 6.27479 20.9284 4.40414 19.7662 3.24186C18.6039 2.07959 16.7332 2.07959 12.9919 2.07959H11.0078C7.26649 2.07959 5.39584 2.07959 4.23356 3.24186ZM7.28756 8.03197C7.28756 7.62105 7.62068 7.28792 8.03161 7.28792H15.9681C16.379 7.28792 16.7122 7.62105 16.7122 8.03197C16.7122 8.4429 16.379 8.77602 15.9681 8.77602H8.03161C7.62068 8.77602 7.28756 8.4429 7.28756 8.03197ZM7.28756 12.0002C7.28756 11.5893 7.62068 11.2562 8.03161 11.2562H15.9681C16.379 11.2562 16.7122 11.5893 16.7122 12.0002C16.7122 12.4112 16.379 12.7443 15.9681 12.7443H8.03161C7.62068 12.7443 7.28756 12.4112 7.28756 12.0002ZM8.03161 15.2244C7.62068 15.2244 7.28756 15.5576 7.28756 15.9685C7.28756 16.3794 7.62068 16.7125 8.03161 16.7125H12.9919C13.4028 16.7125 13.736 16.3794 13.736 15.9685C13.736 15.5576 13.4028 15.2244 12.9919 15.2244H8.03161Z",
    fill: "url(#paint0_linear_528_349)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_528_349",
    x: 0.0947266,
    y: -0.904785,
    width: 23.8096,
    height: 24.8096,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.65
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_528_349"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_528_349",
    x1: 3.87858,
    y1: 4.94707,
    x2: 22.9321,
    y2: 7.61592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BBFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521875,
    stopColor: "#8629FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC4AF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosterIcon);
export default __webpack_public_path__ + "static/media/poster-icon.e640454352910c555d2b2e2efdbe32df.svg";
export { ForwardRef as ReactComponent };